import { GoogleLogin }  from "react-google-login";
const clientid = '425916914844-jd2m6rae8avaqt111e10lifcg0g0fp7v.apps.googleusercontent.com';

const onSuccess = (res) => {
  console.log('Login success: current user', res.profileObj);
  console.log('    login success res', res);
  /*
  // res.profileObj:
  email: "sohale@gmail.com"
  familyName: "Siadat"
  givenName: "Sohail"
  googleId: "117762994354366367518"
  imageUrl: "https://lh3.googleusercontent.com/a/AEdFTp4RVeSy7XtIerIHs2zKS9kmSQInTKV-l1DPt-jpIg=s96-c"
  name: "Sohail Siadat"

  res: accessToken, googleId, tokenId, tokenObj
  wt,xc

  */
  const u = res.profileObj;

  // warning:  global state
  // DOES NOT WORK:
  global.app_global_state.user_id =  u.googleId;

  const welcome_str = `Hello ${u.givenName} ${u.familyName} (${u.name}), thanks for logging in using ${u.email} . Your google-id is ${u.googleId}.`;
  document.body.append(welcome_str);
  document.body.append('     \n     ');
}

const onFailure = (res) => {
  console.log('Login failed. res:', res);
  // DOES NOT WORK:
  global.app_global_state.user_id = 'nouser';
}

function Login() {
  return(
    <span id="SignInButton">
      <GoogleLogin
        clientId={clientid}
        ____client_id={clientid}
        buttonText="Login"
        onSuccess={onSuccess}
        onFailure={onFailure}
        cookiePolicy={'single_host_origin'}
        isSignedIn={true}
      />
    </span>
  );
}

export default Login;
